export default __webpack_public_path__ + "static/media/chat.92c8d51d.svg";